import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './privacy-policy.component.html'
})
export class PrivacyPolicyComponent {}
